import { render, staticRenderFns } from "./Clicked.vue?vue&type=template&id=c939ffe0&scoped=true&"
import script from "./Clicked.vue?vue&type=script&lang=js&"
export * from "./Clicked.vue?vue&type=script&lang=js&"
import style0 from "./Clicked.vue?vue&type=style&index=0&id=c939ffe0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c939ffe0",
  null
  
)

export default component.exports